module.exports = __webpack_public_path__ + "media/images/ficha-320839d5d3383cc3f996fc02070b2af0.png";